import { IconName, IconNames } from "@blueprintjs/icons";

export const NONE = "(none)";
export type IconNameType = IconName | typeof NONE;

export const getIconNames = (): IconNameType[] => {
  const list = Object.entries(IconNames).map(([, name]) => name);
  return Array.from(new Set(list));
};
